import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0e3f19a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = { class: "like justify-between" }
const _hoisted_3 = { class: "like-info flex justify-center items-center" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "like-info flex justify-center items-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "linearSpace" }, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "flex items-center justify-center mt-12 br16 altBackground p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgContainer = _resolveComponent("SvgContainer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("my_favorites")), 1)
    ]),
    (_ctx.result && _ctx.result.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mt-12 br16 altBackground p-4 overflow-y-auto fix-height",
          ref: "scrollContainer",
          onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
        }, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result, (like) => {
              return (_openBlock(), _createElementBlock("li", {
                key: like.customerId
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      src: like.image,
                      alt: like.fullName
                    }, null, 8, _hoisted_4)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h3", null, _toDisplayString(like.fullName), 1)
                  ]),
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.iLike(like, $event)),
                    class: "like-info flex justify-center items-center cursor-pointer"
                  }, [
                    (like.ilike === true)
                      ? (_openBlock(), _createBlock(_component_SvgContainer, {
                          key: 0,
                          name: "blueHeartFilled"
                        }))
                      : (_openBlock(), _createBlock(_component_SvgContainer, {
                          key: 1,
                          name: "blueHeart"
                        }))
                  ], 8, _hoisted_6)
                ]),
                _hoisted_7
              ]))
            }), 128))
          ])
        ], 544))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("dont_have_any_favorite_player")), 1)
        ]))
  ]))
}